import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { TextField } from "@mui/material";

function CustomerReview({
    reviewOpen,
    setReviewOpen,
    formData,
    setFormData,
    errors,
    setErrors,
    handleFileChange,
}) {
    return  <Accordion expanded={reviewOpen} onChange={() => setReviewOpen(!reviewOpen)}>
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panelCustomerReviews-content"
              id="panelCustomerReviews-header"
            >
              <Box display="flex" alignItems="center" gap={1}>
                <Typography variant="h4" fontWeight="semibold" style={{ color: "#2E2E3A" }}>
                  Customer Reviews
                </Typography>
              </Box>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction="row" spacing={3}>
                <Grid item xs={12} md={6}>
                  <Typography
                    variant="body2"
                    fontWeight="medium"
                    color="#9A9AAF"
                    mb={1}
                    name="customerReviews"
                    style={{ fontSize: "14px" }}
                  >
                    Section Title(H2)
                  </Typography>
                  <TextField
                    label=""
                    className="form-input"
                    fullWidth
                    placeholder=""
                    value={formData?.customerReviews}
                    error={Boolean(errors?.customerReviews)}
                    helperText={errors?.customerReviews}
                    onChange={(e) => {
                      setErrors((prev) => ({ ...prev, customerReviews: "" }));
                      setFormData((prev) => ({
                        ...prev,
                        customerReviews: e.target.value,
                      }));
                    }}
                  />
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
}
export default CustomerReview
